import React from 'react';
import PropType from 'prop-types';
import { Stepper as MuiStepper, Step as MuiStep, StepLabel } from '@material-ui/core';
import StepIcon from 'components/Stepper/StepIcon';
import StepConnector from 'components/Stepper/StepConnector';

const Stepper = ({
  steps,
  activeStep,
  skippedSteps,
  getActiveStep,
  ...props
}) => (
  <MuiStepper activeStep={activeStep} {...props}>
    {steps.map((step, index) => (
      <MuiStep key={step.label} completed={!skippedSteps.has(index) && index < activeStep}>
        <StepLabel
          StepIconComponent={p => <StepIcon skipped={skippedSteps.has(index)} {...p} />}
        >
          {step.label}
        </StepLabel>
      </MuiStep>
    ))}
  </MuiStepper>
);

Stepper.propTypes = {
  steps: PropType.arrayOf(PropType.shape({})).isRequired,
  activeStep: PropType.number.isRequired,
  skippedSteps: PropType.shape({}),
  connector: PropType.shape({}),
};

Stepper.defaultProps = {
  skippedSteps: new Set(),
  connector: <StepConnector />,
};

export default Stepper;
